<template>
  <!-- breadcrumbs -->
  <div class="mk-bc mb-2">
    <a class="mk-bc__link" @click="back">{{designLabStore.currentProductCategoryName}}</a>
    <span class="mk-bc__text">{{product.name}}</span>
  </div>

  <div class="mk-product__box">
    <!-- placeholder -->
    <div v-if="loading" class="row">
      <div class="col-12 col-md-6 placeholder-glow mb-5" style="min-height: 400px;">
        <div class="placeholder col-10 h-100 d-block m-auto"></div>
      </div>

      <div class="col-12 col-md-6 placeholder-glow">
        <div class="mb-4">
          <div class="placeholder col-8 pb-4"></div>
        </div>

        <div class="mb-3">
          <div class="placeholder col-6 pb-4"></div>
        </div>

        <div class="mb-5">
          <div class="placeholder col-2 pb-4 me-1"></div>
          <div class="placeholder col-2 pb-4"></div>
        </div>

        <div class="mb-4">
          <div class="placeholder col-6 pb-4"></div>
        </div>

        <div>
          <div class="placeholder col-7 pb-4"></div>
        </div>

      </div>
    </div>

    <!-- product -->
    <div  v-if="!loading" class="row">
      <!-- carousel -->
      <div class="col-12 col-md-6">
        <div class="mk-product__carousel">
          <Carousel targetID="product-carousel" imageClass="mk-image-cover" :imageUrls="imageUrls"></Carousel>
        </div>
      </div>

      <!-- product design info -->
      <div class="col-12 col-md-6">
        <div class="mk-product__design-info h-100">
          <div class="d-flex flex-column justify-content-between h-100"> 

            <div>
              <h1>{{product.name}}</h1>
              <div class="mk-product__color-info">
                <span>顏色：</span>
              </div>

              <div class="mk-product__color-badge-select-box">
                <div 
                  v-for = "(option, index) in productOptions" 
                  :key  = "`product-option-${index}`" 
                  class ="mk-badge mk-badge--color mk-product__color-badge"
                  :style="{'background-color': option.color_code}"
                  @click="changeColorCode(option.color_code)"
                >
                  <img 
                    :class="{'d-block': currentSelectedColorCode == option.color_code}"
                    :src="checkColorUrl(option.check_color)"
                  >
                </div>
              </div>

              <div class="mk-product__size-info">
                <div>可選尺碼：</div>
                <div class="mk-product__size-desc">
                  <div v-for="(size, index) in currentSizes" :key="`product-size-${index}`">
                    <span class="mk-product__size">{{size}}</span> 
                    <span v-if="index != currentSizes.length-1" class="mk-product__size-divider"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center w-100">
              <button class="mk-btn mk-product__design-btn" @click="changeProduct">開始設計產品</button>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="mk-product__box">
    <div class="row">
      <div class="col-12"><h2>產品訊息</h2></div>

      <div class="col-12 col-md-6">
        <div class="mk-product__info-content">
          <div class="w-100">
            <h3>材質特徵</h3>
            <div class="mk-hr"></div>
          </div>

          <div v-html="product.description"></div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="mk-product__info-content">
          <div class="w-100">
            <h3>其它詳細訊息</h3>
            <div class="mk-hr"></div>
          </div>
        </div>
      </div>
      
      <div v-html="product.product_layout_blocks"></div>
    </div>
  </div>
</template>

<script setup>
  import {defineProps, defineEmits, onMounted, ref, computed, nextTick} from 'vue'
  import {useDesignLabStore} from "./DesignLabStore.js"
  import {GetImageUrl} from "~/javascripts/utils.js"
  import Carousel from "./carousel.vue";

  const designLabStore = useDesignLabStore();

  const props = defineProps({
    productSlug: String,
  });

  const emit = defineEmits(["onChangeProduct", "onClickBack"]);

  const changeProduct = () => {
    emit("onChangeProduct", currentProductOption.value.vg_id);
  }

  const product                  = ref({});
  const imageUrls                = ref([]);
  const productOptions           = ref([]);
  const currentSelectedColorCode = ref("");
  const currentSizes             = ref([]);
  const loading                  = ref(true);

  const currentProductOption = computed(()=>{
    return productOptions.value.find(e => e.color_code == currentSelectedColorCode.value);
  });

  const checkColorUrl = (color_code)=>{
    return GetImageUrl(`icons/${color_code}_check.svg`)
  };

  const changeColorCode = (color_code)=>{
    currentSelectedColorCode.value = color_code || "";
    currentSizes.value             = currentProductOption?.value.sizes || [];
  }

  const back = () => {
    emit("onClickBack");
  }

  onMounted(async ()=>{
    const [productData, _] = await designLabStore.getProduct(props.productSlug);

    product.value        = productData;
    imageUrls.value      = product.value.image_urls;
    productOptions.value = product.value.product_options;

    changeColorCode(productOptions.value[0]?.color_code);

    nextTick(()=>{
      setTimeout(()=>{
        loading.value = false;
      }, 150);
    })
  });
</script>